import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { authQuery } from "../../../utils/authQuery";
import { config } from "../../../config";
import {
  CsvImportUploadCommand,
  CsvImportUploadResult,
  CsvImportConfirmCommand,
  CsvImportConfirmResult,
  CsvImportCancelCommand,
  CsvImportCancelResult,
  CsvImportStatusQuery,
  CsvImportStatusResult,
} from "../model";

export const CsvImportApi = createApi({
  reducerPath: "csvImportApi",
  baseQuery: authQuery({ baseUrl: config.baseUrl }),
  tagTypes: ["CsvImport"],
  endpoints: (builder) => ({
    // Upload CSV file and get preview
    csvImportUpload: builder.mutation<CsvImportUploadResult, CsvImportUploadCommand>({
      query: (cmd: CsvImportUploadCommand) => ({
        url: `csvImportUpload`,
        method: "POST",
        body: cmd,
      }),
      transformResponse: (response: CsvImportUploadResult[]) => response[0],
      invalidatesTags: ["CsvImport"],
    }),

    // Confirm import with duplicate actions
    csvImportConfirm: builder.mutation<CsvImportConfirmResult, CsvImportConfirmCommand>({
      query: (cmd: CsvImportConfirmCommand) => ({
        url: `csvImportConfirm`,
        method: "POST",
        body: cmd,
      }),
      transformResponse: (response: CsvImportConfirmResult[]) => response[0],
      invalidatesTags: ["CsvImport"],
    }),

    // Cancel import
    csvImportCancel: builder.mutation<CsvImportCancelResult, CsvImportCancelCommand>({
      query: (cmd: CsvImportCancelCommand) => ({
        url: `csvImportCancel`,
        method: "POST",
        body: cmd,
      }),
      transformResponse: (response: CsvImportCancelResult[]) => response[0],
      invalidatesTags: ["CsvImport"],
    }),

    // Get import status
    csvImportStatus: builder.query<CsvImportStatusResult, CsvImportStatusQuery>({
      query: (body: CsvImportStatusQuery) => ({
        url: `csvImportStatus`,
        method: "POST",
        body: body,
      }),
      transformResponse: (response: CsvImportStatusResult[]) => response[0],
      providesTags: ["CsvImport"],
    }),
  }),
  refetchOnFocus: false,
  refetchOnMountOrArgChange: false,
});

export const {
  useCsvImportUploadMutation,
  useCsvImportConfirmMutation,
  useCsvImportCancelMutation,
  useCsvImportStatusQuery,
  useLazyCsvImportStatusQuery,
} = CsvImportApi;
